(function () {
  "use strict";

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  function esc(s) {
    return (s == null ? "" : String(s)).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  ready(function () {
    var root = document.getElementById("os-store-locator");
    if (!root) return;
    var resultsEl = document.getElementById("os-sl-results");
    var stores = Array.isArray(window.OS_STORES) ? window.OS_STORES : null;

    if (!stores || !stores.length) {
      if (resultsEl) resultsEl.innerHTML = '<p class="os-sl-msg">The store list is unavailable right now. Please try again later.</p>';
      return;
    }

    var GROUP_ORDER = ["ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA", "NZ"];
    var GROUP_LABEL = {
      ACT: "Australian Capital Territory", NSW: "New South Wales", NT: "Northern Territory",
      QLD: "Queensland", SA: "South Australia", TAS: "Tasmania", VIC: "Victoria",
      WA: "Western Australia", NZ: "New Zealand"
    };

    var cfg = {
      markerColor: root.getAttribute("data-marker-color") || "#fcee21",
      centerLat: parseFloat(root.getAttribute("data-map-center-lat")) || -28.0,
      centerLng: parseFloat(root.getAttribute("data-map-center-lng")) || 134.0,
      zoom: parseInt(root.getAttribute("data-map-zoom"), 10) || 4,
      nearest: 8
    };

    // ---------- Map ----------
    var map = L.map("os-sl-map", { scrollWheelZoom: false }).setView([cfg.centerLat, cfg.centerLng], cfg.zoom);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 18, attribution: "&copy; OpenStreetMap contributors"
    }).addTo(map);

    function markerIcon() {
      return L.divIcon({
        className: "os-sl-pin-wrap",
        html: '<span class="os-sl-pin" style="background:' + esc(cfg.markerColor) + '"></span>',
        iconSize: [22, 22], iconAnchor: [11, 11], popupAnchor: [0, -11]
      });
    }

    function fullAddress(s) {
      return [s.address, s.city, (s.state || s.country), s.postcode].filter(Boolean).join(", ");
    }

    function directionsLinks(s, label) {
      var g = "https://www.google.com/maps/dir/?api=1&destination=" + s.lat + "," + s.lng;
      var a = "https://maps.apple.com/?daddr=" + s.lat + "," + s.lng;
      if (label === "short") {
        return '<a class="os-sl-card-dir" href="' + g + '" target="_blank" rel="noopener">Directions</a>';
      }
      return '<a class="os-sl-dir" href="' + g + '" target="_blank" rel="noopener">Google Maps</a> ' +
             '<a class="os-sl-dir" href="' + a + '" target="_blank" rel="noopener">Apple Maps</a>';
    }

    function popupHtml(s) {
      var h = "<strong>" + esc(s.name) + "</strong><br>" + esc(fullAddress(s));
      if (s.phone) h += '<br><a href="tel:' + esc(s.phone.replace(/\s+/g, "")) + '">' + esc(s.phone) + "</a>";
      if (s.email) h += '<br><a href="mailto:' + esc(s.email) + '">' + esc(s.email) + "</a>";
      if (s.website) {
        var w = /^https?:/i.test(s.website) ? s.website : "https://" + s.website;
        h += '<br><a href="' + esc(w) + '" target="_blank" rel="noopener">Website</a>';
      }
      h += "<br>" + directionsLinks(s, "full");
      return h;
    }

    var cluster = L.markerClusterGroup();
    var markers = [];
    stores.forEach(function (s, i) {
      var m = L.marker([s.lat, s.lng], { icon: markerIcon() }).bindPopup(popupHtml(s));
      markers[i] = m;
      cluster.addLayer(m);
    });
    map.addLayer(cluster);

    function focusStore(i) {
      var s = stores[i];
      if (!s) return;
      map.flyTo([s.lat, s.lng], 13, { duration: 0.6 });
      cluster.zoomToShowLayer(markers[i], function () { markers[i].openPopup(); });
      var mapEl = document.getElementById("os-sl-map");
      if (mapEl && typeof mapEl.scrollIntoView === "function") {
        mapEl.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    }

    // ---------- Distance ----------
    function distance(lat1, lng1, lat2, lng2) {
      var R = 6371, dLat = (lat2 - lat1) * Math.PI / 180, dLng = (lng2 - lng1) * Math.PI / 180;
      var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    function nearestTo(lat, lng) {
      return stores
        .map(function (s, i) { return { i: i, dist: distance(lat, lng, s.lat, s.lng) }; })
        .sort(function (a, b) { return a.dist - b.dist; })
        .slice(0, cfg.nearest);
    }

    // ---------- Store cards + results ----------
    function storeCardHtml(s, i, dist) {
      var h = '<div class="os-sl-card">';
      h += '<button type="button" class="os-sl-card-name" data-i="' + i + '">' + esc(s.name) + "</button>";
      h += '<div class="os-sl-card-addr">' + esc(fullAddress(s)) + "</div>";
      if (s.phone) h += '<div class="os-sl-card-phone"><a href="tel:' + esc(s.phone.replace(/\s+/g, "")) + '">' + esc(s.phone) + "</a></div>";
      if (typeof dist === "number") h += '<div class="os-sl-card-dist">' + dist.toFixed(1) + " km away</div>";
      h += directionsLinks(s, "short");
      h += "</div>";
      return h;
    }

    function renderResults(title, items) {
      if (!items.length) {
        resultsEl.innerHTML = '<p class="os-sl-msg">No stores found. Try another postcode or browse by state below.</p>';
        return;
      }
      var html = '<h3 class="os-sl-results-title">' + esc(title) + "</h3>";
      html += items.map(function (it) { return storeCardHtml(stores[it.i], it.i, it.dist); }).join("");
      resultsEl.innerHTML = html;
    }

    // Delegated click: any .os-sl-card-name focuses its store.
    root.addEventListener("click", function (e) {
      var btn = e.target.closest ? e.target.closest(".os-sl-card-name") : null;
      if (btn) focusStore(parseInt(btn.getAttribute("data-i"), 10));
    });

    // ---------- Browse-by-state accordions ----------
    (function renderAccordions() {
      var groups = {};
      stores.forEach(function (s, i) { (groups[s.group] = groups[s.group] || []).push(i); });
      var html = "";
      GROUP_ORDER.forEach(function (g) {
        var idxs = groups[g];
        if (!idxs || !idxs.length) return;
        idxs.sort(function (a, b) {
          return (stores[a].city || "").localeCompare(stores[b].city || "") ||
                 stores[a].name.localeCompare(stores[b].name);
        });
        html += '<details class="os-sl-acc"><summary class="os-sl-acc-sum">' +
                esc(GROUP_LABEL[g]) + ' <span class="os-sl-acc-count">' + idxs.length + "</span></summary>";
        html += '<div class="os-sl-acc-body">' +
                idxs.map(function (i) { return storeCardHtml(stores[i], i); }).join("") + "</div>";
        html += "</details>";
      });
      document.getElementById("os-sl-accordions").innerHTML = html;
    })();

    // ---------- Search + autocomplete ----------
    var input = document.getElementById("os-sl-input");
    var clearBtn = document.getElementById("os-sl-clear");
    var acEl = document.getElementById("os-sl-autocomplete");
    var searchBtn = document.getElementById("os-sl-search");
    var locateBtn = document.getElementById("os-sl-locate");

    var places = {}; // "Suburb STATE postcode" -> {lat,lng}
    stores.forEach(function (s) {
      var label = [s.city, (s.state || "NZ"), s.postcode].filter(Boolean).join(" ");
      if (label && !places[label]) places[label] = { lat: s.lat, lng: s.lng };
    });
    var placeLabels = Object.keys(places);

    function resolveOrigin(query) {
      var ql = query.toLowerCase();
      var label = placeLabels.filter(function (l) { return l.toLowerCase() === ql; })[0];
      if (label) return places[label];
      var byPostcode = stores.filter(function (s) { return s.postcode && s.postcode === query; })[0];
      if (byPostcode) return { lat: byPostcode.lat, lng: byPostcode.lng };
      var byCity = stores.filter(function (s) { return (s.city || "").toLowerCase().indexOf(ql) === 0; })[0];
      if (byCity) return { lat: byCity.lat, lng: byCity.lng };
      return null;
    }

    function doSearch(query) {
      query = (query || "").trim();
      if (!query) return;
      var origin = resolveOrigin(query);
      if (!origin) { renderResults("Results", []); return; }
      renderResults("Stores near " + query, nearestTo(origin.lat, origin.lng));
      map.flyTo([origin.lat, origin.lng], 11, { duration: 0.6 });
    }

    input.addEventListener("input", function () {
      var v = this.value.trim().toLowerCase();
      acEl.innerHTML = "";
      if (!v) return;
      placeLabels
        .filter(function (l) { return l.toLowerCase().indexOf(v) !== -1; })
        .slice(0, 8)
        .forEach(function (l) {
          var d = document.createElement("div");
          d.className = "os-sl-ac-item";
          d.textContent = l;
          d.addEventListener("click", function () { input.value = l; acEl.innerHTML = ""; doSearch(l); });
          acEl.appendChild(d);
        });
    });
    input.addEventListener("keydown", function (e) { if (e.key === "Enter") { acEl.innerHTML = ""; doSearch(this.value); } });
    clearBtn.addEventListener("click", function () { input.value = ""; acEl.innerHTML = ""; input.focus(); });
    searchBtn.addEventListener("click", function () { acEl.innerHTML = ""; doSearch(input.value); });
    document.addEventListener("click", function (e) {
      if (!acEl.contains(e.target) && e.target !== input) acEl.innerHTML = "";
    });

    // ---------- Use my location ----------
    locateBtn.addEventListener("click", function () {
      if (!navigator.geolocation) {
        resultsEl.innerHTML = '<p class="os-sl-msg">Location isn\'t supported by your browser. Please search or browse by state.</p>';
        return;
      }
      locateBtn.disabled = true;
      navigator.geolocation.getCurrentPosition(
        function (pos) {
          locateBtn.disabled = false;
          var items = nearestTo(pos.coords.latitude, pos.coords.longitude);
          renderResults("Stores near you", items);
          if (items.length) map.flyTo([stores[items[0].i].lat, stores[items[0].i].lng], 11, { duration: 0.6 });
        },
        function () {
          locateBtn.disabled = false;
          resultsEl.innerHTML = '<p class="os-sl-msg">We couldn\'t get your location. Please search by postcode or browse by state.</p>';
        },
        { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 }
      );
    });

    // Leaflet needs a size recalc when its container was hidden/animated on load.
    setTimeout(function () { map.invalidateSize(); }, 200);
  });
})();
